export { API, BACKEND_URL } from '@/config/api';
import { FileText, TrendingDown, TrendingUp, AlertTriangle } from 'lucide-react';

export const getWeekNumber = (dateString) => {
  const date = new Date(dateString);
  const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
  const pastDaysOfYear = (date - firstDayOfYear) / 86400000;
  return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
};

export const getStatusConfig = (status) => {
  switch(status) {
    case 'draft':
      return {
        color: 'bg-slate-100 text-slate-800 border-slate-200',
        icon: FileText,
        label: 'Utkast (ikkje sendt)', 
        iconColor: 'text-slate-600',
        bgColor: 'bg-slate-50'
      };
    case 'sent':
      return {
        color: 'bg-blue-100 text-blue-800 border-blue-200',
        icon: TrendingUp,
        label: 'Sendt til kunde',
        iconColor: 'text-blue-600',
        bgColor: 'bg-blue-50'
      };
    case 'critical':
      return {
        color: 'bg-red-100 text-red-800 border-red-200',
        icon: AlertTriangle,
        label: 'Raud', 
        iconColor: 'text-red-600',
        bgColor: 'bg-red-50'
      };
    case 'monitor':
      return {
        color: 'bg-amber-100 text-amber-800 border-amber-200',
        icon: TrendingUp,
        label: 'Overvåking',
        iconColor: 'text-amber-600',
        bgColor: 'bg-amber-50'
      };
    default:
      return {
        color: 'bg-emerald-100 text-emerald-800 border-emerald-200', 
        icon: TrendingDown,
        label: 'Låge forhold',
        iconColor: 'text-emerald-600',
        bgColor: 'bg-emerald-50'
      };
  }
};
